import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import Postulante from './modulos/Postulante';
import Sectores from './modulos/Sectores';
import NivelEstudio from './modulos/NivelEstudio';
import Pasos from './modulos/Pasos';

export const store = new Vuex.Store({
  modules: {
    postulante: Postulante,
    sectores: Sectores,
    nivel_estudio: NivelEstudio,
    pasos: Pasos
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js